import React from 'react';
import styled from 'styled-components';

import { classList } from '@/helpers';

interface IInputLabelProps {
  children?: string;
  required: boolean;
  className?: string;
  htmlFor: string;
}

const InputLabel = ({ children, required, className, htmlFor }: IInputLabelProps): React.ReactElement => {
  if (!children) {
    <></>;
  }

  return (
    <Label htmlFor={htmlFor} className={classList('input-label-container', className)}>
      {required && <span className="input-label-required-mark text-danger me-1">*</span>}
      {children}
    </Label>
  );
};

export { InputLabel };

const Label = styled.label`
  font-size: 16px;
  color: #374151;
  line-height: 24px;
  margin-bottom: 8px;
`;
